/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

 
const buildingIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-nonfinance.svg";
const calendarIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-calendar.svg";

const thumbsUpIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-other.svg";
const coinIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-sales.png";
const priceBagIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-finance.png";

const bankIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-bank.png";
const umbrellaIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-insurance.png";
const noneIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-experience-none.svg";

const reasonToJoin = {
  question: "how can Wealthy help you succeed?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "reason_to_join",
  options: [
    {
      icon: coinIcon,
      title: "by helping me establish a second source of income",
      subtitle: "",
      next: null,
      value: "second income source"
    },
    {
      icon: priceBagIcon,
      title: "by allowing me to start my own finance business",
      subtitle: "",
      next: null,
      value: "start own finance business"
    }
  ]
};

const previousJobRole = {
  question: "what was your function at your last job?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "profession_role",
  options: [
    {
      icon: coinIcon,
      title: "sales",
      value: "sales",
      next: reasonToJoin
    },
    {
      icon: thumbsUpIcon,
      title: "other",
      value: "other",
      next: reasonToJoin
    }
  ]
};

const lastActiveAt = {
  question: "when did you quit?",
  description:
      "this will help us know you better as a wealth partner",
  answerKey: "last_active_duration",
  options: [
    {
      icon: calendarIcon,
      title: "less than 6 months",
      value: "<6m",
      next: previousJobRole
    },
    {
      icon: calendarIcon,
      title: "6 months - 1 year",
      value: "6m-1y",
      next: previousJobRole
    },
    {
      icon: calendarIcon,
      title: "more than a year",
      value: ">1y",
      next: previousJobRole
    }
  ]
};

const freelanceQuestions = {
  icon: thumbsUpIcon,
  title: "i’m not working at a job right now",
  // subtitle: "i'm not working right now",
  value: "DOT",
  next: {
    question: "which sector was your last job in?",
    answerKey: "product_experience",
    description:
        "this will help us know you better as a wealth partner",
    options: [
      {
        icon: bankIcon,
        title: "banking sector",
        subtitle: "HDFC, ICICI, SBI etc",
        value: "BS",
        next: lastActiveAt
      },
      {
        icon: umbrellaIcon,
        title: "insurance company",
        subtitle: "ICICI Lombard, HDFC Ergo, LIC etc",
        value: "IC",
        next: lastActiveAt
      },
      {
        icon: buildingIcon,
        title: "other financial company",
        subtitle: "finance org, neither banking nor insurance",
        value: "OFC",
        next: lastActiveAt
      },
      {
        icon: thumbsUpIcon,
        title: "non financial company",
        subtitle: "non financial org",
        value: "NFC",
        next: lastActiveAt
      },
      {
        icon: noneIcon,
        title: "i have not worked for a company",
        subtitle: "i haven't started my professional career yet",
        value: "NWC",
        next: reasonToJoin
      }
    ]
  }
};

export default freelanceQuestions;
